// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__wplsG","label":"LabeledBox_label__2R8Jp"};